<template>
  <div class="form-group row">
    <div class="col-sm-12">
      <button type="button" class="btn btn-primary pull-left" @click="goBack" v-if="!noBack">
        <span class="fas fa-chevron-left"></span> Back
      </button>
      <button type="submit" class="btn btn-primary float-right" @click="sendFormData" :disabled="isSubmitting">
        <slot name="next">Next <span class="fas fa-chevron-right"></span></slot>
      </button>
    </div>
  </div>
</template>

<script>
  import EventBus from '@/utils/EventBus'

  export default {
    data () {
      return {
        isSubmitting: false
      }
    },
    methods: {
      goBack () {
        EventBus.$emit('go-back')
      },
      sendFormData () {
        this.beforeSubmit().then(() => {
          EventBus.$emit('submit-form', this.toSubmit)
        })
      }
    },
    mounted () {
      EventBus.$on('ajax-start', () => {
        this.isSubmitting = true
      })
      EventBus.$on('ajax-stop', () => {
        this.isSubmitting = false
      })
    },
    props: {
      beforeSubmit: {
        type: Function,
        default: () => Promise.resolve()
      },
      noBack: {
        type: Boolean,
        default: false
      },
      toSubmit: Object
    }
  }
</script>

<style scoped>

</style>
